module.exports = __webpack_public_path__ + "static/media/0904A4.81dfe8ef.jpg";